
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluBagkurCevap } from '@/plugins/uyap-plugin/uyap/DosyaBorcluBagkur';

@Component({})
export default class BagkurAktifDetay extends Vue {
  @Prop() data!: DosyaBorcluBagkurCevap;

  // DEV-3354: UYAP 4/b kayıtlarını üst seviyedeki tescilKaydi4BList yerine
  // tescilKaydi4b.tesciller altında döndürüyor; islemSonuc/anaHataMesaji da yer değiştirdi.
  get tescilKaydi() {
    return this.data.sorguSonucDVO?.tescilKaydi4b;
  }

  get tescilKayitlari() {
    return this.tescilKaydi?.tesciller || [];
  }

  get sonucAciklamasi() {
    return this.tescilKaydi?.islemSonucAciklama || this.data.sorguSonucDVO?.hataMesaji || '';
  }

  get hasData() {
    return this.tescilKayitlari && this.tescilKayitlari.length > 0;
  }

  formatDate(dateNumber: number | string | null | undefined): string {
    if (!dateNumber) return '';
    const dateStr = String(dateNumber);
    if (dateStr.length === 8) {
      // Format: YYYYMMDD -> DD.MM.YYYY
      return `${dateStr.substring(6, 8)}.${dateStr.substring(4, 6)}.${dateStr.substring(0, 4)}`;
    }
    return dateStr;
  }

  getAlertType() {
    return this.tescilKaydi?.islemSonuc === 0 ? 'success' : 'warning';
  }
}
